<template>
  <v-app id="agentCom">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
          <v-col cols="2">
            <v-select v-model="agntCodesSelected" :items="agntCodes" item-value="agtnCode"  item-text="agtnNaam" label="Agents" multiple></v-select>
          </v-col>
        </v-row>

      <!--
      <v-row>
          <v-col cols="2">
            <v-select v-model="param.maandKeuze" :items="maandCodes" item-value="maandCode"  item-text="maandOms" label="Year / Month"></v-select>
          </v-col>
      </v-row>  
      -->

      <v-row>
         <v-col cols="2">
            <v-menu
              v-model="dat1menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.van_dat" 
              label="From date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.van_dat2" :first-day-of-week="1" @input="param.van_dat = $moment(param.van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
            </v-menu>  
          </v-col>

          <v-col cols="2">
            <v-menu
              v-model="dat2menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.tm_dat" 
              label="Until date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.tm_dat2" :first-day-of-week="1" @input="param.tm_dat = $moment(param.tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
            </v-menu>  
          </v-col>

      </v-row>  
     


     
      <v-row>
          <v-col cols="2">
            <v-select v-model="param.destKeuze" :items="destCodes" item-value="destCode"  item-text="destOms" label="Destination"></v-select>
          </v-col>
      </v-row>  

      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted" @click="ovrz">Send Commission per Email</v-btn>
          </v-col> 
      </v-row>

    </v-container>
     
    </v-main>
    <navBar title="Ares - Finance" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar,
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      maandCodesSelected: '',
      maandCodes: [],
      destCodesSelected: '',
      destCodes: [],
      dat1menu: false,
      dat2menu: false,
      submitted: false,
      param: {},
      agntCodes: [],
      agntCodesSelected: [],
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/ovrz/getAgentCom1Param.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getAgentCom1Param"
        },
        getAgentCom1Param: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getAgentCom1Param; 
           res.data.getAgentCom1Param.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getAgentCom1Param.maandKeuzes.forEach(function(maand) {
             deze.maandCodes.push(maand);
           });
           res.data.getAgentCom1Param.destKeuzes.forEach(function(dest) {
             deze.destCodes.push(dest);
           });
           this.agntCodes = res.data.getAgentCom1Param.agtnKeuzes;
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.submitted = true;
      this.$axios
        .post("ares/json/ares/task/fin/ovrz/excelExportAgentCom1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportAgentCom1"
          },
          excelExportAgentCom1: {
            bedr_codes: this.bedrCodesSelected,
            agnt_codes: this.agntCodesSelected,
            maandJaar: this.param.maandKeuze,
            van_dat: this.param.van_dat,
            tm_dat: this.param.tm_dat,
            destination: this.param.destKeuze
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            //this.items = res.data.excelExportAgentCom1;
            this.submitted = false;

            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.excelExportAgentCom1.text,
              color: res.data.excelExportAgentCom1.color,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
